import { render, staticRenderFns } from "./CommonCardGame.vue?vue&type=template&id=2603dc9e&scoped=true&"
import script from "./CommonCardGame.vue?vue&type=script&lang=ts&"
export * from "./CommonCardGame.vue?vue&type=script&lang=ts&"
import style0 from "./CommonCardGame.vue?vue&type=style&index=0&id=2603dc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2603dc9e",
  null
  
)

export default component.exports